gsap.registerPlugin(ScrollTrigger);
gsap.utils.toArray('.js-video-animate').forEach(function (container) {
  triggerVideoParallax(container);
});
gsap.utils.toArray('.js-img-animate').forEach(function (container) {
  triggerParallax(container);
});

function triggerParallax(container) {
  var image = container.querySelector('img');
  var tl = gsap.timeline({
    scrollTrigger: {
      trigger: container,
      scrub: true,
      pin: false,
    },
  });

  tl.from(image, {
    yPercent: -30,
    ease: 'none',
  }).to(image, {
    yPercent: 30,
    ease: 'none',
  });
}
/**
 * Function to activate the parallax motion for the video on the home page using ScrollTrigger
 * @param {*} container - container that holds the animated element
 */
function triggerVideoParallax(container) {
  let video = container.querySelector('video');
  let tl = gsap.timeline({
    scrollTrigger: {
      trigger: container,
      scrub: true,
      pin: false,
    },
  });

  tl.from(video, {
    yPercent: -30,
    ease: 'none',
  }).to(video, {
    yPercent: 30,
    ease: 'none',
  });
}

class CustomVideoControls extends HTMLElement {
  constructor() {
    super();
    this.video = document.querySelector('details-video video');
    this.playBtn = this.querySelector('.playPause');
    this.muteBtn = this.querySelector('.muteUnmute');
    this.videoControl = this.querySelector('.video-controls');
    this.attachEvents();
    this.setBottom();

    window.addEventListener('resize', function () {
      const videoElement = document.getElementById('hero-video');
      const desktopSource = document.getElementById('desktop-source');
      const mobileSource = document.getElementById('mobile-source');
      const isPaused = videoElement.paused;
      const currentTime = videoElement.currentTime;

      if (window.innerWidth > 767) {
        // Set desktop video source
        videoElement.src = desktopSource.src;
        videoElement.poster = desktopSource.poster;
      } else {
        // Set mobile video source
        videoElement.src = mobileSource.src;
        videoElement.poster = mobileSource.poster;
      }

      // Load the new video source
      videoElement.load();

      videoElement.currentTime = currentTime;
      if (isPaused) {
        videoElement.pause();
      } else {
        videoElement.play();
      }
    });
  }

  attachEvents() {
    if (this.video) {
      document.querySelector('#playPause').addEventListener('click', this.playPauseHandler.bind(this));
      document.querySelector('#muteUnmute').addEventListener('click', this.muteUnmuteHandler.bind(this));
      window.addEventListener('scroll', this.setBottom.bind(this));
    }
  }

  playPauseHandler() {
    if (this.playBtn.classList.contains('pause')) {
      this.video.pause();
      this.playBtn.classList.remove('pause');
      this.playBtn.classList.add('play');
      this.playBtn.setAttribute('aria-label', 'Play'); // Update aria-label
    } else if (this.playBtn.classList.contains('play')) {
      this.video.play();
      this.playBtn.classList.remove('play');
      this.playBtn.classList.add('pause');
      this.playBtn.setAttribute('aria-label', 'Pause'); // Update aria-label
    }
  }

  muteUnmuteHandler() {
    if (this.muteBtn.classList.contains('unmuted')) {
      this.video.muted = true;
      this.muteBtn.classList.remove('unmuted');
      this.muteBtn.classList.add('muted');
      this.muteBtn.setAttribute('aria-label', 'Unmute'); // Update aria-label
    } else if (this.muteBtn.classList.contains('muted')) {
      this.video.muted = false;
      this.muteBtn.classList.remove('muted');
      this.muteBtn.classList.add('unmuted');
      this.muteBtn.setAttribute('aria-label', 'Mute'); // Update aria-label
    }
  }

  setBottom() {
    if (window.scrollY === 0) {
      this.videoControl.style.bottom = '2.5rem';
    } else {
      if (this.isDesktopView) {
        this.videoControl.style.bottom = '0.5rem';
      } else {
        this.videoControl.style.bottom = '0.25rem';
      }
    }
  }
}

customElements.define('details-video', CustomVideoControls);
